import React from 'react'
import styled from '@emotion/styled'
import { SectionTitle } from './styles'
import { string, array } from 'prop-types'

// import components
import { ReviewCard } from './ReviewCard'

const ReviewsWrapper = styled.div`
	margin: auto;
	width: 90%;
	${({ theme }) => theme.MQ.M} {
		width: 100%;
	}
`
const SectionTitleStyles = styled(SectionTitle)`
	margin: 2.5rem 0;
`
OurReviews.propTypes = {
	title: string.isRequired,
	reviews: array.isRequired,
}

/**
 * This is the Revies section of the Mega Best Picks, displays the Best Picks Review of the service
 * @param {String} props.title :: section title, coming from ccm
 * @param {Array} props.reviews :: list of services
 */
export function OurReviews({ title, reviews }) {
	return (
		<ReviewsWrapper>
			<SectionTitleStyles>{title}</SectionTitleStyles>
			{reviews &&
				reviews
					.filter((review) => !!review.review.reviewContent)
					.map((review, i) => {
						return <ReviewCard key={i} {...review} rank={i} />
					})}
		</ReviewsWrapper>
	)
}
